import React, { useState, useEffect } from 'react';
import { Menu, X, Linkedin, Mail, Phone } from 'lucide-react';

const Header = ({ data }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#about', label: 'About' },
    { href: '#projects', label: 'Projects' },
    { href: '#journey', label: 'Journey' },
    { href: '#expertise', label: 'Expertise' },
    { href: '#contact', label: 'Contact' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      scrolled 
        ? 'bg-[#0a1628]/95 backdrop-blur-md py-4 shadow-lg shadow-black/20' 
        : 'bg-transparent py-6'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a 
            href="#" 
            className="group flex items-center gap-3"
            onClick={(e) => scrollToSection(e, '#hero')}
          >
            <div className="w-10 h-10 border-2 border-[#d4af37] flex items-center justify-center group-hover:bg-[#d4af37] transition-all duration-300">
              <span className="font-display text-lg font-bold text-[#d4af37] group-hover:text-[#0a1628] transition-colors">VB</span>
            </div>
            <span className="hidden sm:block font-display text-xl text-white font-semibold">Vaibhav Bhore</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-[#94a3b8] text-sm font-medium tracking-wide uppercase hover:text-[#d4af37] transition-colors duration-300 relative group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#d4af37] group-hover:w-full transition-all duration-300" />
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <a
            href={data.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:flex items-center gap-2 bg-[#d4af37] text-[#0a1628] px-5 py-2.5 text-sm font-semibold hover:bg-[#e8c547] transition-all duration-300"
          >
            <Linkedin size={16} />
            Connect
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-[#d4af37] p-2"
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-6 py-6 border-t border-[#d4af37]/20 animate-fade-up">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link, index) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-white text-lg font-medium py-2 hover:text-[#d4af37] transition-colors"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {link.label}
                </a>
              ))}
              <a
                href={data.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 flex items-center justify-center gap-2 bg-[#d4af37] text-[#0a1628] px-6 py-3 font-semibold"
              >
                <Linkedin size={18} />
                Connect on LinkedIn
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
